import type { ContentSummary } from 'bundles/course-v2/types/ContentSummary';
import type { ItemType } from 'bundles/item/types/ItemType';

export type DegreeItemProgressState =
  | 'NotStarted'
  | 'Started'
  | 'InReview'
  | 'Completed'
  | 'Failed'
  | 'Optional'
  | 'Overdue';

export type ComputedProgress = {
  progressState: DegreeItemProgressState;
  progressPercent: number;
};

export type NotGradedItemOutcome = {
  computedAt: number;
};

export type GradedItemOutcome = {
  isPassed: boolean;
  grade: number;
};

export function isGradedItemOutcome(outcome: NotGradedItemOutcome | GradedItemOutcome): outcome is GradedItemOutcome {
  return (outcome as GradedItemOutcome).grade !== undefined;
}

export type ComputedOutcome = {
  org_coursera_degree_learner_Outcome?: GradedItemOutcome | NotGradedItemOutcome;
};

export type Deadline = {
  dueAt: number;
  isOverdue: boolean;
};

export type Item = {
  id: string;
  slug: string;
  name: string;
  typeName: ItemType;
  contentSummary: ContentSummary;
  timeCommitment: number;
  computedProgress: ComputedProgress;
  computedOutcome: ComputedOutcome;
  deadline: Deadline;
};

type InProgressState = {
  activeSessionId?: string;
  hasEnrollableSession?: boolean;
};

type NotStartedState = {
  activeSessionId?: string;
  hasEnrollableSession?: boolean;
};

type CourseProgressState = {
  typeName: string;
  inProgress?: InProgressState;
  notStarted?: NotStartedState;
};

export type DegreeCourse = {
  id: string;
  slug: string;
  name: string;
  itemStates?: Array<Item>;
  completedDate?: number;
  courseProgressState?: CourseProgressState;
};
